// Standalone +/- handler for <s-quantity-selector> (no imports, works without the import map).
(() => {
  if (window.__bscentQtyButtons) return;
  window.__bscentQtyButtons = true;

  const sync = (root) => {
    const input = root.querySelector('input');
    if (!input) return;
    const min = parseInt(root.getAttribute('min') || input.min || '1', 10);
    const maxAttr = root.getAttribute('max') || input.max;
    const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    const value = parseInt(input.value, 10) || min;
    const dec = root.querySelector('[data-decrement]');
    const inc = root.querySelector('[data-increment]');
    if (dec) dec.disabled = value <= min;
    if (inc) inc.disabled = value >= max;
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('s-quantity-selector [data-decrement], s-quantity-selector [data-increment]');
    if (!btn) return;
    e.preventDefault();
    const root = btn.closest('s-quantity-selector');
    const input = root.querySelector('input');
    if (!input || input.disabled) return;
    const min = parseInt(root.getAttribute('min') || input.min || '1', 10);
    const maxAttr = root.getAttribute('max') || input.max;
    const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    const step = parseInt(root.getAttribute('step') || input.step || '1', 10) || 1;
    const current = parseInt(input.value, 10) || min;
    const next = btn.hasAttribute('data-increment') ? current + step : current - step;
    const clamped = Math.min(max, Math.max(min, next));
    if (clamped === current) return;
    input.value = String(clamped);
    root.setAttribute('value', String(clamped));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    sync(root);
  });

  document.addEventListener('input', (e) => {
    const root = e.target.closest?.('s-quantity-selector');
    if (root) sync(root);
  });

  const init = () => document.querySelectorAll('s-quantity-selector').forEach(sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
